import { Component, Input, inject } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { CaptureService } from '../../../core/services/capture.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-capture-reprocess',
    templateUrl: './capture-reprocess.component.html',
    styleUrls: ['./capture-reprocess.component.scss'],
    imports: [NgbPopover, DatePipe]
})
export class CaptureReprocessComponent {
  private captureService = inject(CaptureService);

  @Input() capture: Capture;

  reprocessCaptureClick() {
    this.captureService.reprocess(this.capture).subscribe((modifiedCapture: Capture) => {
      this.captureService.notifyCaptureChanged(modifiedCapture);
    });
  }
}
